import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { LogService } from '../../services/log-service';
import { getMessages } from '../../store/pusher/fallback-api';
import { useOnComponentMount } from '../../hooks/use-on-component-mount';
import style from './style.module.less';

const PushNotificationPoller = ({ pollingIntervalInMS, jobGuid, onPushNotificationsDiscovered, shouldShowLoader = false }) => {
  const [isFetching, setIsFetching] = useAsyncSafeState();
  const wakeupAndCheckTheJob = useCallback(() => {
    setIsFetching(true);
    getMessages(jobGuid)
      .then((response) => {
        const { messages } = response;
        if (messages && messages.length) {
          onPushNotificationsDiscovered(messages);
        }
      })
      .catch((e) => LogService.logError(new Error('Error encountered while polling for push notifications', { cause: e }), { jobGuid }))
      .finally(() => setIsFetching(false));
  }, [jobGuid, onPushNotificationsDiscovered, setIsFetching]);

  useOnComponentMount(() => {
    const intervalId = setInterval(() => {
      wakeupAndCheckTheJob();
    }, pollingIntervalInMS);

    return () => clearInterval(intervalId);
  }, []);

  if (!shouldShowLoader) {
    return null;
  }

  return <div className={style['loading-icon']}>{isFetching && <LoadingIndicator />}</div>;
};

PushNotificationPoller.propTypes = {
  pollingIntervalInMS: PropTypes.number.isRequired,
  jobGuid: PropTypes.string.isRequired,
  onPushNotificationsDiscovered: PropTypes.func.isRequired,
  shouldShowLoader: PropTypes.bool,
};

export default PushNotificationPoller;
